/* VH Discount Bundles skin (sections/vh-bundles-skin.liquid). PRESENTATION ONLY: reads the theme's custom-product-grid DOM;
   never moves, hides or edits its cards, form or links; no cart, storage or network calls. */
(function () {
  var hero = document.getElementById('vh-bundles-skin');
  var sec = document.querySelector('[class^="regional-product-section-"]');
  if (!hero || !sec) return;
  var q = function (s, r) { return (r || sec).querySelector(s); };
  /* hero text = the theme section's own heading/subtitle (one source) */
  var t = q('[class^="product-grid-title-"]'), st = q('[class^="product-grid-subtitle-"]');
  if (t && t.textContent.trim()) hero.querySelector('[data-vh-from="title"]').textContent = t.textContent.trim();
  if (st && st.textContent.trim()) hero.querySelector('[data-vh-from="subtitle"]').textContent = st.textContent.trim();
  sec.closest('.shopify-section') && sec.closest('.shopify-section').classList.add('vh-bds-on');
  /* hero stack: the first three bundle photos the theme rendered for this viewer (tag gating is server-side) */
  var stack = hero.querySelector('.vh-bd-stack');
  var imgs = Array.prototype.slice.call(sec.querySelectorAll('[class^="product-card-"] img')).slice(0, 3);
  imgs.forEach(function (im, i) {
    var n = document.createElement('img');
    n.src = im.currentSrc || im.src; n.alt = ''; n.width = 700; n.height = 700; n.className = 'vh-bd-s' + (i + 1);
    if (i) n.loading = 'lazy';
    stack.insertBefore(n, stack.lastElementChild);
  });
  stack.setAttribute('data-n', imgs.length);
  /* JPG photos can't be transparent (Global's V-Tedetox plans are on white): show them on a rounded plate */
  Array.prototype.slice.call(sec.querySelectorAll('[class^="product-image-wrapper-"] img')).forEach(function (im) {
    if (/\.jpe?g(\?|$)/i.test(im.getAttribute('src') || '')) im.parentNode.classList.add('vh-bd-plate');
  });
  /* "Save $X" next to a struck compare-at price (the theme's own two price spans) */
  var money = function (s) { var m = String(s).replace(/[^\d.,]/g, '').replace(/,(?=\d{3}\b)/g, ''); return parseFloat(m.replace(',', '.')); };
  Array.prototype.slice.call(sec.querySelectorAll('[class^="product-price-"]')).forEach(function (p) {
    var sp = p.querySelectorAll('span');
    if (sp.length < 2 || p.querySelector('.vh-bd-save')) return;
    var was = money(sp[0].textContent), now = money(sp[sp.length - 1].textContent);
    if (!(was > now)) return;
    var cur = (sp[sp.length - 1].textContent.match(/[^\d\s.,]+/) || ['$'])[0];
    var chip = document.createElement('span');
    chip.className = 'vh-bd-save';
    chip.textContent = 'Save ' + cur + (was - now).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    p.appendChild(chip);
  });
})();
